export const incidentKeys = {
  base: ['incidentSettings'] as const,
  get: (id: string) => [...incidentKeys.base, id] as const,
};
